export const NETWORK_GRAPH_SCHEMA = 'dmf-network-graph-index.v2' as const;
export const NETWORK_GRAPH_WORKER_PROTOCOL = 'dmf.network-graph-worker.v2' as const;

export const WEB_NETWORK_GRAPH = {
  artifactUrl:
    '/app/artifacts/graph/sha256-b683ee92936b354055c9ef0e148a09e4525a8332496492f55aaecfca0a1b9d24/graph.json.gz',
  attribution:
    'Railway topology © OpenStreetMap contributors, ODbL 1.0; country extract provided by Geofabrik GmbH; modified for Der Maschinfuehrer.',
  catalogVersion: 'sha256-b328e6e04ebb4f082ef0600b110bf0868163cce785b247a1084a83fd114522ed',
  coverageLabel: 'napojená místa katalogu v Česku a Německu',
  coreEdgeCount: 1_435_327,
  edgeCount: 1_505_694,
  endpointConnectorEdgeCount: 70_367,
  formatVersion: '2.0.0',
  graphVersion: 'sha256-b683ee92936b354055c9ef0e148a09e4525a8332496492f55aaecfca0a1b9d24',
  licenseUrl: 'https://opendatacommons.org/licenses/odbl/1-0/',
  readmeUrl:
    '/app/artifacts/graph/sha256-b683ee92936b354055c9ef0e148a09e4525a8332496492f55aaecfca0a1b9d24/README.txt',
  vertexCount: 1_491_993,
} as const;
